export const enum Platform {
  Web = 'web',
  Android = 'android',
  Ios = 'ios',
}

export const enum DisplayMode {
  FILL = 'fill',
  FLOATING = 'floating',
  FULLSCREEN = 'fullscreen',
}

export const PLATFORMS: Array<{ label: string; value: Platform }> = [
  { label: 'Web', value: Platform.Web },
  { label: 'Android', value: Platform.Android },
  { label: 'iOS', value: Platform.Ios },
]

export const MOBILE_PLATFORMS: Array<{ label: string; value: Platform }> = [
  { label: 'Android', value: Platform.Android },
  { label: 'iOS', value: Platform.Ios },
]

export const WEB_PLATFORM: Array<{ label: string; value: Platform }> = [
  { label: 'Web', value: Platform.Web },
]

export const DISPLAY_MODES: Array<{ label: string; value: DisplayMode }> = [
  { label: 'Full Screen', value: DisplayMode.FULLSCREEN },
  { label: 'Floating', value: DisplayMode.FLOATING },
  { label: 'Inline', value: DisplayMode.FILL },
]

export const ThemePlatformPathMap = {
  [Platform.Web]: 'contentWeb',
  [Platform.Android]: 'contentAndroid',
  [Platform.Ios]: 'contentIos',
}

export const PLATFORM_TO_MEASUREMENT_UNIT_MAP = {
  [Platform.Web]: 'px',
  [Platform.Ios]: 'pt',
  [Platform.Android]: 'dp',
}
